import { jsx as _jsx } from "react/jsx-runtime";
import { Separator, Stack } from '../../../index.js';
export const MenuSeparator = () => _jsx(Stack, { as: "li", role: "none", vPadding: 8, hPadding: 16, children: _jsx(Separator, {}) });
